import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export default (personalPronoun) => {
  const { t, i18n } = useTranslation('personal_pronouns');
  const existingPronoun = useMemo(() => {
    const personalPronounValue = i18n.exists(`personal_pronouns:${personalPronoun}`);
    return personalPronounValue ? t(personalPronoun) : personalPronoun;
  });
  return existingPronoun;
};
